import {
	validateText,
	validatePhone,
	validateMail,
	validationField,
} from "./validations/validationsUpdated.js";

export default function contactJs() {
	let fErrors = {};
	const mForm = document.querySelector("#form");
	const submitButton = mForm.querySelector("#formSubmit");
	const fullName = mForm.querySelector("#fullname");
	const phone = mForm.querySelector("#phone");
	const email = mForm.querySelector("#email");
	const address = mForm.querySelector("#address");
	const fMessage = mForm.querySelector("#message");
	const companyName = mForm.querySelector("#companyname");
	const sender = document.querySelectorAll('input[name="Sender"]');

	sender.forEach((elem) => {
		elem.addEventListener("click", function () {
			if (this.value == "Individual") {
				companyName.disabled = true;
				companyName.value = "";
			} else {
				companyName.disabled = false;
			}
		});
	});

	validationField(email, "blur", validateMail, fErrors);
	validationField(fullName, "blur", validateText, fErrors);
	validationField(phone, "blur", validatePhone, fErrors);
	validationField(address, "blur", null, fErrors);

	submitButton.addEventListener("click", async function (e) {
		e.preventDefault();
		let hasErrors = false;
		validationField(email, null, validateMail, fErrors);
		validationField(fullName, null, validateText, fErrors);
		validationField(phone, null, validatePhone, fErrors);
		validationField(address, null, null, fErrors);

		hasErrors ? null : await SubmitContactForm();
	});

	async function SubmitContactForm(form) {
		let data = {
			FullName: fullName.value,
			Phone: phone.value,
			Email: email.value,
			Address: address.value,
			Message: fMessage.value,
			Sender: document.querySelector('input[name="Sender"]:checked').value,
			CompanyName: companyName.value,
		};

		const formEndpoint = "/umbraco/surface/Contact/SubmitContact";
		fetch(formEndpoint, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				culture: `${document.documentElement.lang}`,
				RequestVerificationToken: `${
					document.querySelector('input[name="__RequestVerificationToken"]')
						.value
				}`,
				//_recaptcha: token,
			},
			body: JSON.stringify(data),
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.statusCode == 200) {
					document.querySelector(".js-form-result-success").innerHTML =
						data.message;
					document
						.querySelector(".js-form-result-success")
						.classList.remove("hidden");
					mForm.reset();
					document.body.classList.remove("loading");
				} else {
					document.querySelector(".js-form-result-failure").innerHTML =
						data.message;
					document
						.querySelector(".js-form-result-failure")
						.classList.remove("hidden");
					document.body.classList.remove("loading");
				}
			});
	}
}
